// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header {
  --box-shadow: none !important;
  box-shadow: 0px 4px 45px 0px rgba(0, 0, 0, 0.0784313725) !important;
}

ion-content {
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 16px;
  --padding-bottom: 16px;
  --background: var(--ion-color-secondary);
}

.title {
  font-family: AppFontSemiBold;
  font-size: 18px;
  line-height: 120%;
  letter-spacing: 0.04em;
  vertical-align: middle;
  margin-bottom: 16px;
  text-transform: uppercase;
  color: #2a2416;
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  height: -moz-fit-content;
  height: fit-content;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(46%, 1fr));
  gap: 10px;
}
.wrapper .item {
  min-height: 165px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 14px 12px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid var(--ion-color-primary);
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.wrapper .item::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 16px;
  background: linear-gradient(160deg, rgba(205, 165, 60, 0.12), transparent 60%);
  opacity: 0.6;
  pointer-events: none;
}
.wrapper .item:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(16, 24, 8, 0.14);
}
.wrapper .item ion-img {
  height: 90px;
  object-fit: contain;
  margin-bottom: 10px;
}
.wrapper .item .name {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.04em;
  text-align: center;
  margin-bottom: 3px;
  color: #2a2416;
  text-transform: uppercase;
}
.wrapper .item .info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFont;
  font-size: 12px;
  line-height: 110%;
  letter-spacing: 0;
  vertical-align: middle;
  color: rgba(42, 36, 22, 0.75);
}

.spinner-wrapper {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/select-category/select-category.page.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;EACA,mEAAA;AADD;;AAIA;EACC,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EAEA,wCAAA;AAFD;;AAaA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AAVD;;AAaA;EACC,WAAA;EACA,iBAAA;EACA,cAAA;EACA,wBAAA;EAAA,mBAAA;EAEA,aAAA;EACA,0DAAA;EACA,SAAA;AAXD;AAaC;EACC,iBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EAEA,eAAA;EACA,kBAAA;EACA,qDACC;AAdH;AAiBE;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,8EAAA;EACA,YAAA;EACA,oBAAA;AAfH;AAkBE;EACC,2BAAA;EACA,6CAAA;AAhBH;AAmBE;EACC,YAAA;EACA,mBAAA;EAEA,mBAAA;AAlBH;AAsBE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AApBH;AAuBE;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EAEA,6BAAA;AAvBH;;AA4BA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzBD","sourcesContent":["@use '../../../theme/mixins' as *;\n\nion-header {\n\t--box-shadow: none !important;\n\tbox-shadow: 0px 4px 45px 0px #00000014 !important;\n}\n\nion-content {\n\t--padding-start: 16px;\n\t--padding-end: 16px;\n\t--padding-top: 16px;\n\t--padding-bottom: 16px;\n\n\t--background: var(--ion-color-secondary);\n}\n\n// .page-shell {\n// \tmin-height: 100%;\n// \tbackground: radial-gradient(120% 120% at 50% -20%, #ffffff 0%, #f7f2e7 60%, #efe6cf 100%);\n// \tborder-radius: 18px;\n// \tpadding: 18px;\n// \tbox-shadow: inset 0 0 0 1px rgba(205, 165, 60, 0.2);\n// }\n\n.title {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 18px;\n\tline-height: 120%;\n\tletter-spacing: 0.04em;\n\tvertical-align: middle;\n\tmargin-bottom: 16px;\n\ttext-transform: uppercase;\n\tcolor: #2a2416;\n}\n\n.wrapper {\n\twidth: 100%;\n\tmax-width: 1000px;\n\tmargin: 0 auto;\n\theight: fit-content;\n\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fill, minmax(46%, 1fr));\n\tgap: 10px;\n\n\t.item {\n\t\tmin-height: 165px;\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tpadding: 14px 12px;\n\t\tborder-radius: 8px;\n\t\tbackground: #ffffff;\n\t\tborder: 1px solid var(--ion-color-primary);\n\n\t\tcursor: pointer;\n\t\tposition: relative;\n\t\ttransition:\n\t\t\ttransform 0.2s ease,\n\t\t\tbox-shadow 0.2s ease;\n\n\t\t&::after {\n\t\t\tcontent: '';\n\t\t\tposition: absolute;\n\t\t\tinset: 0;\n\t\t\tborder-radius: 16px;\n\t\t\tbackground: linear-gradient(160deg, rgba(205, 165, 60, 0.12), transparent 60%);\n\t\t\topacity: 0.6;\n\t\t\tpointer-events: none;\n\t\t}\n\n\t\t&:hover {\n\t\t\ttransform: translateY(-2px);\n\t\t\tbox-shadow: 0 16px 28px rgba(16, 24, 8, 0.14);\n\t\t}\n\n\t\tion-img {\n\t\t\theight: 90px;\n\t\t\tobject-fit: contain;\n\n\t\t\tmargin-bottom: 10px;\n\t\t\t// filter: drop-shadow(0 6px 10px rgba(0, 0, 0, 0.12));\n\t\t}\n\n\t\t.name {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0.04em;\n\t\t\ttext-align: center;\n\t\t\tmargin-bottom: 3px;\n\t\t\tcolor: #2a2416;\n\t\t\ttext-transform: uppercase;\n\t\t}\n\n\t\t.info {\n\t\t\tmargin: 0;\n\t\t\tflex: 1;\n\t\t\tword-break: break-word;\n\t\t\tdisplay: -webkit-box;\n\t\t\t-webkit-line-clamp: 2;\n\t\t\t-webkit-box-orient: vertical;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\tfont-family: AppFont;\n\t\t\tfont-size: 12px;\n\t\t\tline-height: 110%;\n\t\t\tletter-spacing: 0;\n\t\t\tvertical-align: middle;\n\n\t\t\tcolor: rgba(42, 36, 22, 0.75);\n\t\t}\n\t}\n}\n\n.spinner-wrapper {\n\theight: 100%;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
